/**
 * Which of a task's causes its held items actually have, in the order the task lists them. A task
 * covering several causes with one fix still has to say which one somebody is looking at.
 *
 * @param {import('../model/BillingItem.types').BillingItem[]} items
 * @param {string[]} reasons - the causes the task covers, in the order to name them
 * @returns {string[]}
 */
// eslint-disable-next-line import/prefer-default-export
export function holdCausesIn(items, reasons) {
  const found = new Set(items.flatMap((item) => item.holdReasons ?? []));

  return reasons.filter((reason) => found.has(reason));
} // holdCausesIn()
